
























import MiniSensor from '@/components/mini-sensor/MiniSensor.vue';
import DeviceRoleMapMixin from '@/features/core/components/mixins/device-role-map';
import { BooleanProp, ObjectProp, StringProp } from '@/util/prop-decorators';
import { Component, Mixins } from 'vue-property-decorator';
import { SpotRole } from '@/types/iot-portal';
import { DomainUiSpotInfoSpotFragment_activeDeviceMount } from '@/features/domain-ui/spot-info/__generated__/DomainUiSpotInfoSpotFragment';

interface SpotNameCellType {
  __typename: 'Spot';
  id: string;
  name: string;
  role: SpotRole;
  activeDeviceMount: DomainUiSpotInfoSpotFragment_activeDeviceMount | null;
}

@Component({ components: { MiniSensor } })
export default class SpotNameCell extends Mixins(DeviceRoleMapMixin) {
  @ObjectProp()
  private readonly spot?: SpotNameCellType;

  @StringProp('–')
  private readonly emptyMessage!: string;

  @BooleanProp()
  private readonly disabled!: boolean;

  private get serial(): string | undefined {
    return this.spot?.activeDeviceMount?.serial ?? '–';
  }
}
